<div *ngIf="!isLoading">
  <form [formGroup]="form" class="needs-validation">
    <div class="position-relative row form-group">
      <label for="name_Id" class="col-sm-2 col-form-label"
        >{{ "Form.Question" | translate }}
        <span class="text-danger">*</span></label
      >
      <div class="col-sm-10">
        <input
          formControlName="question"
          name="question"
          id="question_id"
          type="text"
          class="form-control"
          placeholder="Question"
          required
        />
        <div *ngIf="submitted && f.question.errors" class="invalid-feedback">
          <div *ngIf="f.question.errors.required">
            {{ "Form.Error.Question" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button
        style="
          border: none;
          border-radius: 50px;
          background-color: rgb(255, 238, 0);
          width: 25px;
          height: 25px;
          text-align: center;
        "
        (click)="reWriteAnswer()"
      >
        <i
          id="enhance-faqs-with-ai"
          style="font-size: 18px"
          class="fa fa-lightbulb-o"
          title="Enhance FAQs with AI"
        ></i>
      </button>
    </div>
    <div class="position-relative row form-group">
      <label for="answer" class="col-sm-2 col-form-label"
        >{{ "Form.Answer" | translate
        }}<span class="text-danger">*</span></label
      >
      <div class="col-md-10 my-2 py-2">
        <angular-editor
          id="faq-editor"
          formControlName="answer"
          [config]="config"
          required
        ></angular-editor>
        <div *ngIf="submitted && answerError" class="text-danger">
          {{ "Form.Error.Answer" | translate }}
        </div>
      </div>
    </div>

    <div
      class="position-relative row form-group"
      *ngIf="currentFAQ.screenType != 'generic'"
    >
      <label class="col-md-2 col-form-label" for="screenType"
        >{{ "Form.screenType" | translate }}
      </label>
      <div class="col-md-10">
        <div class="custom-radio custom-control">
          <input
            class="custom-control-input"
            id="screenSpecific"
            name="screenType"
            type="radio"
            value="screenSpecific"
            (click)="getScreenDefaultOrder()"
            formControlName="screenType"
          />
          <label class="custom-control-label" for="screenSpecific">{{
            "Form.screenSpecific" | translate
          }}</label>
        </div>

        <div class="custom-radio custom-control">
          <input
            class="custom-control-input"
            id="generic"
            name="screenType"
            type="radio"
            value="generic"
            (click)="getGenericDefaultOrder()"
            formControlName="screenType"
          />
          <label class="custom-control-label" for="generic">{{
            "Form.generic" | translate
          }}</label>
        </div>
      </div>
    </div>

    <div class="position-relative row py-2 my-2 form-group">
      <label for="displayOrder" class="col-sm-2 col-form-label">{{
        "Form.displayOrder" | translate
      }}</label>
      <div class="col-md-4">
        <input
          formControlName="displayOrder"
          name="displayOrder"
          id="displayOrder"
          type="number"
          class="form-control"
        />
      </div>
    </div>

    <div class="position-relative row py-2 my-2 form-group">
      <label for="position" class="col-sm-2 col-form-label">
        {{ "Form.SRoles" | translate }}
      </label>
      <ng-select
        [items]="roles"
        [virtualScroll]="true"
        bindLabel="displayname"
        bindValue="name"
        placeholder="{{ 'Form.SRoles' | translate }}"
        class="ms-1 col-md-4"
        [multiple]="true"
        formControlName="roles"
      >
      </ng-select>
    </div>

    <div class="position-relative row form-check">
      <div class="col-md-9 offset-sm-2 py-2 my-2">
        <button
          class="btn px-3"
          style="margin-right: 10px"
          type="submit"
          [ngClass]="{
            'btn-primary': form.dirty,
            'btn-secondary': !form.dirty
          }"
          [disabled]="!form.dirty"
          (click)="onSubmit()"
        >
          {{ "Form.PublishToDev" | translate }}
        </button>
        <button
          class="btn reset-btn text-white"
          [disabled]="!form.dirty"
          (click)="onReset()"
        >
          {{ "Form.Reset" | translate }}
        </button>
        <button
          class="btn"
          [ngClass]="{
            'btn-primary': !form.dirty && publishToQA,
            'btn-secondary': form.dirty || !publishToQA
          }"
          [disabled]="form.dirty || !publishToQA"
          style="margin-right: 10px; margin-left: 10px"
          (click)="onClickOfPublish('qa')"
        >
          {{ "Form.PublishToQA" | translate }}
        </button>
        <button
          class="btn"
          [ngClass]="{
            'btn-primary': (!form.dirty || publishToProd) && !publishToQA,
            'btn-secondary': form.dirty || !publishToProd
          }"
          [disabled]="form.dirty || !publishToProd"
          (click)="onClickOfPublish('prod')"
        >
          {{ "Form.PublishToProd" | translate }}
        </button>
      </div>
    </div>

    <div class="divider"></div>
  </form>

  <!--  <div
    class="card-header-tab card-header"
    style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
    *ngIf="faq != 'new'"
  >
    <div class="card-title font-size-md text-capitalize">
      {{ "Form.SELECT_LANGUAGE" | translate }}
    </div>
  </div>

  <div
    class="row"
    *ngIf="project && project.supportedLanguage && faq != 'new'"
    style="margin-left: -5px"
  >
    <div
      style="
        padding: 10px;
        cursor: pointer;
        margin-bottom: 4px;
        font-size: 12px;
        height: fit-content;
      "
      class="badge col-2"
      [ngClass]="{
        'badge-primary': currentFAQ.languageId == project.primaryLanguage,
        'badge-secondary': currentFAQ.languageId != project.primaryLanguage
      }"
      (click)="showSelectedLangaugeFAQ(project.primaryLanguage)"
    >
      {{ getLanguageName(project.primaryLanguage) }}
    </div>
    <ng-container *ngFor="let psl of project.supportedLanguage">
      <div
        style="
          padding: 10px;
          cursor: pointer;
          margin-bottom: 4px;
          font-size: 12px;
          height: fit-content;
        "
        *ngIf="psl.id != project.primaryLanguage"
        class="badge ms-2 col-2"
        [ngClass]="{
          'badge-primary': psl.id == currentFAQ.languageId,
          'badge-secondary': psl.id != currentFAQ.languageId
        }"
        (click)="showSelectedLangaugeFAQ(psl.id)"
      >
        {{ psl.name }}
      </div>
    </ng-container>

    <ng-template #content let-c="close" let-d="dismiss" class="lang-popup">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ "Form.SELECT_NEW_LANGUAGE" | translate }}
        </h4>
        <button
          type="button"
          class="close mt-2"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body lang-popup">
        <overlay-scrollbars [defer]="true">
          <mat-selection-list #newLanguages class="me-2">
            <mat-list-option *ngFor="let projectSl of getNewLanguage()">
              {{ projectSl.name }}
            </mat-list-option>
          </mat-selection-list>
        </overlay-scrollbars>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="c('Close click')"
        >
          {{ "Form.CANCEL" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveNewSelectedLanguage(newLanguages)"
        >
          {{ "Form.SAVE" | translate }}
        </button>
      </div>
    </ng-template>
    <div
      style="
        padding: 10px;
        cursor: pointer;
        margin-bottom: 4px;
        font-size: 11px;
        height: fit-content;
      "
      class="badge ms-2 col-2 badge-primary"
      (click)="open(content)"
    >
      +
    </div>
  </div>
 -->
  <div
    class="card-header-tab card-header"
    style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
    *ngIf="currentFAQ.updatedAt"
  >
    <div class="card-title font-size-md text-capitalize">
      {{ "Form.Lastupdatedon" | translate }}
      {{ currentFAQ.updatedAt | date : "yyyy-MM-dd" }}
    </div>
  </div>
</div>
<div *ngIf="isLoading" class="loaderdata">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ "Form.Loading" | translate }}</span>
  </div>
</div>
